export default __webpack_public_path__ + "fb592e5670f113b8c5594324219f8694.svg";